<template>
  <input
    v-if="focused"
    @blur="focused = false"
    ref="ssnInput"
    :class="modifier"
    type="text"
    :id="id"
    :name="name"
    :required="required"
    :autofocus="autofocus"
    v-model="internalValue"
    v-mask="mask"

  >
  <input
    v-else
    :id="id"
    :name="name"
    :class="modifier"
    :value="hashedSSN"
    v-mask="obscuredMask"
    @focus="showSSN"
  >
</template>

<script>
  export default {
    props: {
      autofocus: String,
      minlength: String,
      required: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ''
      },
      name: String,
      id: String,
      disabled: Boolean,
      onFocus: {
        type: Function,
        default() {}
      },
      modifier: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        focused: false
      }
    },
    methods: {
      showSSN() {
        this.focused = true
        this.$nextTick(() => this.$refs.ssnInput.focus())
      }
    },
    computed: {
      mask() {
        try { return this.value.length <= 4 ? '####' : '###-##-####' } catch (error) { return '' };
      },
      obscuredMask() {
        try { return this.value.length <= 4 ? 'XXXX' : 'XXX-XX-XXXX' } catch (error) { return '' }
      },
      hashedSSN() {
        try { return this.value.replace(/[0-9]/g, '#') } catch (error) { return '' }
      },
      internalValue: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('input', newVal.replace(/-/g, ''))
        }
      }
    }
  }
</script>
